.contentPage {
    background: white;
    position: relative;
    width: 100%;
    height: 100%;
}

.backButton {
    display: none;
    position: absolute;
    top: var(--mantine-spacing-md);
    left: var(--mantine-spacing-md);
    z-index: 10;

    @container (min-width: $mantine-breakpoint-sm) {
        display: flex;
    }
}
